import {
    API,
    SITE_API,
    REPORT_GET_ALL_URL,
    REPORT_GET_ALL_SKILLS_URL,
    REPORT_GET_LEADS_URL,
    REPORT_GET_CANDIDATES_URL,
    REPORT_GET_CRM_ACCOUNTS_URL,
    REPORT_GET_SOCIAL_ACCOUNTS_URL,
    REPORT_GET_CRM_ORGANIZATION_URL,
    REPORT_GET_SOCIAL_ORGANIZATION_URL
} from "../variable";

import axios from 'axios'
import {
    REPORT_GET_ALL,
    REPORT_GET_ALL_SKILLS,
    REPORT_GET_LEADS,
    REPORT_GET_CANDIDATES,
    REPORT_GET_CRM_ACCOUNTS,
    REPORT_GET_SOCIAL_ACCOUNTS,
    REPORT_GET_CRM_ORGANIZATION,
    REPORT_GET_SOCIAL_ORGANIZATION
} from "../Actions/report.js";

const state = {

};

const actions = {
    [REPORT_GET_LEADS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + REPORT_GET_LEADS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },
    [REPORT_GET_CANDIDATES]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + REPORT_GET_CANDIDATES_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },
    [REPORT_GET_CRM_ACCOUNTS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + REPORT_GET_CRM_ACCOUNTS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },
    [REPORT_GET_SOCIAL_ACCOUNTS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + REPORT_GET_SOCIAL_ACCOUNTS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken }
        });
    },
    [REPORT_GET_CRM_ORGANIZATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + REPORT_GET_CRM_ORGANIZATION_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },
    [REPORT_GET_SOCIAL_ORGANIZATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + REPORT_GET_SOCIAL_ORGANIZATION_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken }
        });
    },
    [REPORT_GET_ALL_SKILLS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + getters.get_crm_prefix + REPORT_GET_ALL_SKILLS_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.siteAuthToken }
        });
    },
    [REPORT_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API + getters.get_crm_prefix + REPORT_GET_ALL_URL,
            method: "POST",
            data: validatePayloadData(payload),
            headers: { 'Authorization': 'Bearer ' + sessionStorage.authToken }
        });
    },
};

const mutations = {};

const getters = {};

export default {
    state,
    getters,
    actions,
    mutations
};